<section class="calendarHeader white-bg fill z2" [class.border-bottom]="!topNotification">
  <div class="titleArea" [ngClass]="titleAreaConfig.titleAreaStyle">
    <div class="title grow flex" [ngClass]="{ 'flex--column flex--baseline flex--align-start': subTitle }">
      @if (titleAreaConfig?.title || uiLabels?.title) {
        <h2
          class="overflow-hidden nordic-blue-900-text ms-clear-t"
          [ngClass]="titleAreaConfig.titleStyle"
          [class.flex--self-center]="subTitle === undefined"
          tabindex="-1"
          data-focus-on-modal-open
          data-testid="datepicker-title"
          #titleElement
        >
          {{
            dateSelectedLabel() ? dateSelectedLabel() : titleAreaConfig?.title ? titleAreaConfig.title : uiLabels?.title
          }}
        </h2>
      }
      @if (subTitle) {
        <ng-container *ngTemplateOutlet="subTitle" />
      }
    </div>

    <div class="controls flex flex--middle flex--start">
      <button
        (click)="clearDates()"
        class="reset font-body-1 regular-type nordic-blue-900-text underline ms-small-r"
        data-testid="datepicker-reset"
        data-focus-on-modal-open
      >
        {{ uiLabels?.reset }}
      </button>

      <div class="inputs flex flex--wrap ms-xsmall-x">
        <div class="fill flex border rounded">
          <div
            class="inputArea flex flex-1 ps-xxsmall-x ps-xsmall-y"
            [class.border-right]="isDateRange"
            [class.invalid]="startDateError()"
          >
            <fcom-icon class="icon-medium flex--nogrow" [name]="SvgLibraryIcon.DEPARTURE" />
            <input
              data-testid="datepicker-departure-date"
              [attr.aria-label]="uiLabels?.selectStartDate"
              aria-describedby="dp-startDate-error"
              autocomplete="off"
              class="flex-1 font-body-1 regular-type nordic-blue-900-text border-none mr-xxsmall-l"
              id="dp-startDate"
              maxlength="10"
              [attr.placeholder]="uiLabels?.inputPlaceholder"
              type="text"
              name="startDate"
              [(ngModel)]="startDate"
              (blur)="setDate($event)"
              (keyup.enter)="setDate($event)"
              inputmode="text"
            />
          </div>
          @if (isDateRange) {
            <div class="inputArea flex flex-1 ps-xsmall-l ps-xxsmall-r ps-xsmall-y" [class.invalid]="endDateError()">
              <fcom-icon class="icon-medium flex--nogrow" [name]="SvgLibraryIcon.ARRIVAL" />
              <input
                data-testid="datepicker-return-date"
                [attr.aria-label]="uiLabels?.selectEndDate"
                aria-describedby="dp-endDate-error"
                autocomplete="off"
                class="flex-1 font-body-1 regular-type nordic-blue-900-text border-none mr-xxsmall-l"
                id="dp-endDate"
                maxlength="10"
                [attr.placeholder]="uiLabels?.inputPlaceholder"
                type="text"
                name="endDate"
                [(ngModel)]="endDate"
                (blur)="setDate($event)"
                (keyup.enter)="setDate($event)"
                inputmode="text"
              />
            </div>
          }
        </div>
        <span
          id="dp-startDate-error"
          class="inputError fill ps-xxsmall-l font-body-1 heather-700-text heather-50-bg border heather-700-border rounded-bottom-left rounded-bottom-right"
          [class.is-hidden]="!startDateError()"
          aria-live="assertive"
        >
          {{ startDateError() }}
        </span>
        @if (isDateRange) {
          <span
            id="dp-endDate-error"
            class="inputError fill ps-xxsmall-l font-body-1 heather-700-text heather-50-bg border heather-700-border rounded-bottom-left rounded-bottom-right"
            [class.is-hidden]="!endDateError()"
            aria-live="assertive"
          >
            {{ endDateError() }}
          </span>
        }
      </div>
      @if (showAddReturn) {
        <fcom-button
          data-testid="datepicker-add-return"
          [text]="'uiLabels.addReturn' | finLocalization"
          [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.LEFT }"
          [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
          (click)="addReturn.emit()"
        />
      }
    </div>

    <div class="close flex flex--end">
      <button [attr.aria-label]="uiLabels?.close" class="rounded" (click)="closeDatepicker()">
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CLOSE_DELETE" />
      </button>
    </div>
  </div>
  @if (headerTemplate) {
    <ng-container [ngTemplateOutlet]="headerTemplate" />
  }
  @if (topNotification && (isMobile$ | async)) {
    <fcom-notification
      data-testid="datepicker-top-notification-mobile"
      class="block pr-small-t pr-clear-y ms-xsmall-x ms-xsmall-y"
      [theme]="NotificationTheme.INFO"
      [layout]="NotificationLayout.BLOCK"
      [iconCategory]="IconLibrary.SVG_LIBRARY"
      [iconName]="topNotificationIcon"
      [scale]="NotificationScale.SMALL"
    >
      {{ topNotification }}
    </fcom-notification>
  }
</section>

@if (topNotification && (isMobile$ | async) === false) {
  <fcom-notification
    data-testid="datepicker-top-notification"
    class="block pr-small-t pr-clear-y ms-medium-x ms-xsmall-y"
    [theme]="NotificationTheme.INFO"
    [layout]="NotificationLayout.BLOCK"
    [iconCategory]="IconLibrary.SVG_LIBRARY"
    [iconName]="topNotificationIcon"
    [scale]="NotificationScale.SMALL"
  >
    {{ topNotification }}
  </fcom-notification>
}

<fcom-calendar
  class="block ms-xsmall-x ms-xsmall-t"
  [dateLabels]="dateLabels"
  [uiLabels]="uiLabels"
  [isDateRange]="isDateRange"
  [selectedDates]="selectedDateSelection()"
  [disabledDateRanges]="disabledDateRanges"
  [showTags]="showTags"
  [dayTemplate]="dayTemplate"
  [scrollToMonthIndex$]="scrollToMonthIndex$"
  [minDate]="minDate()"
  [maxDate]="maxDate()"
  (monthChange)="monthChange.emit($event)"
  (datesSelected)="onDatesSelected($event)"
/>
@if (startDate() || endDate()) {
  <output data-testid="datepicker-vishidden-dates" class="is-vishidden">
    {{ uiLabels?.selectedDates }}: {{ startDate() }}, {{ endDate() }}
  </output>
}

@if (!doneBtnHidden) {
  <section class="ps-large nordic-blue-50-bg fill flex--center flex stickyFooter">
    <fcom-button (clickBtn)="closeDatepicker()" [text]="uiLabels?.done" class="font-body-2" />
  </section>
}
